import { EAppActions } from "../AppContext/types.js";
/* -------------------------------------------------------------------------------------------------
 * App
 * -----------------------------------------------------------------------------------------------*/
const setErrorReporting = (errorReportingEnabled, dispatch) => dispatch({
    type: EAppActions.SET_ERROR_REPORTING,
    payload: { errorReportingEnabled },
});
const setConnectWalletOpen = (walletConnectOpen, dispatch) => dispatch({
    type: EAppActions.CONNECT_WALLET_OPEN,
    payload: { walletConnectOpen },
});
const setWrongNetworkOpen = (wrongNetworkOpen, dispatch) => dispatch({
    type: EAppActions.SET_WRONG_NETWORK_OPEN,
    payload: { wrongNetworkOpen },
});
/* -------------------------------------------------------------------------------------------------
 * Export
 * -----------------------------------------------------------------------------------------------*/
export const Actions = {
    setErrorReporting,
    setConnectWalletOpen,
    setWrongNetworkOpen,
};
//# sourceMappingURL=actions.js.map